import { ReactNode } from 'react';

interface StackedContentColProps {
  children: ReactNode;
  cols: '4' | '5' | '6' | '10';
  desktopOrder?: '1' | '2';
}

function StackedContentCol({
  children,
  cols,
  desktopOrder
}: StackedContentColProps) {
  return (
    <div className={`stacked-content-col stacked-content-col-md-${cols} order-lg-${desktopOrder || 0}`} data-testid={cols === "10" ? "col1" : "col2"}>
      {children}
    </div>
  )
}

interface StackedContentProps {
  alignStart?: boolean;
  justifyStart?: boolean;
  children: ReactNode;
}

export function StackedContent({ alignStart, justifyStart, children }: StackedContentProps) {
  return (
    <div className="stacked-content">
      <div className={`stacked-content-row${alignStart ? ' align-items-start' : ''}${justifyStart ? ' justify-content-start' : ''}`}>
        {children}
      </div>
    </div>
  )
}

export default Object.assign(StackedContent, {
  Col1: StackedContentCol,
  Col2: StackedContentCol,
});
